import React from 'react';

import { InputAdornment } from '@material-ui/core';
import { Search } from '@material-ui/icons';

import { func, string, bool } from 'prop-types';
import generate from 'shortid';

import Button from '../Button';
import InputMasked from '../InputMasked';

import { Container } from './styles';

const InputCep = ({ handleChange, value, handleClick, isLoading, label, id, margin, themecolor, ...others }) => {
  const freigthButton = {
    width: margin === 'dense' ? '38.5px' : '54.5px',
    height: margin === 'dense' ? '38.5px' : '54.5px',
    title: 'Buscar',
    onClick: handleClick,
    Icon: () => <Search />,
    iconSize: '30px',
    isLoading,
  };

  return (
    <Container container>
      <InputMasked
        {...others}
        id={id}
        fullWidth
        value={value}
        label={label}
        margin={margin}
        mask="99999-999"
        variant="outlined"
        themecolor={themecolor}
        onChange={handleChange}
        onKeyDownCapture={(ev) => (ev.keyCode === 13 ? handleClick(ev) : null)}
        disabled={isLoading || others.disabled}
        inputProps={{
          type: 'tel',
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Button {...freigthButton} disabled={isLoading || others.disabled} color={themecolor} />
            </InputAdornment>
          ),
        }}
      />
    </Container>
  );
};

InputCep.defaultProps = {
  handleClick: () => {},
  handleChange: () => {},
  value: '',
  isLoading: false,
  label: 'Calcular Frete',
  id: generate(),
  margin: 'normal',
};

InputCep.propTypes = {
  handleClick: func,
  handleChange: func,
  value: string,
  isLoading: bool,
  freight: bool,
  label: string,
  id: string,
  margin: string,
  themecolor: string,
};

export default InputCep;
